import React, { useState, useEffect } from 'react';
import ProductImageGalleryMobile from './ProductImageGalleryMobile';
import ProductImageGalleryDesktop from './ProductImageGalleryDesktop';

const DESKTOP_BREAKPOINT_PX = 768;

/**
 * Галерея зображень товару: обгортка, яка показує окремий компонент для мобільної та десктопної версії.
 * items: array of { original: url, thumbnail?: url } or url strings
 * showThumbnails: boolean
 */
const ProductImageGallery = ({ items = [], showThumbnails = true }) => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT_PX}px)`);
    const update = () => setIsDesktop(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  if (isDesktop) {
    return <ProductImageGalleryDesktop items={items} showThumbnails={showThumbnails} />;
  }
  return <ProductImageGalleryMobile items={items} showThumbnails={showThumbnails} />;
};

export default ProductImageGallery;
